<template>
  <div class="reply">
    <van-pull-refresh
      :disabled="$store.state.loginStatus === 0 ? true : false"
      v-model="refreshing"
      success-text="刷新成功"
      @refresh="onRefresh"
      v-swipeup="(e) => vueTouch('上滑', e)"
    >
      <van-list
        v-show="itemList.length != 0"
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        :offset="1"
        error-text="请求失败，点击重新加载"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="reply_item"
          v-show="itemList.length > 0"
          v-for="item in itemList"
          :key="item.id"
        >
          <div class="reply_item_headbox" @click="listClick(item)">
            <img
              v-show="pageId != 4"
              :src="item.fromMemberAvatar"
              @error="defImg()"
              @click.stop="goUserPage(item)"
              alt=""
            />
            <img
              v-if="pageId == 4 && $store.state.gameType == 1"
              src="@/assets/img/officialHeader.png"
              alt=""
            />
            <img
              v-show="pageId == 4 && $store.state.gameType == 2"
              src="@/assets/img/officialHeader1.jpg"
              alt=""
            />
            <img
              v-show="pageId == 4 && $store.state.gameType == 3"
              src="@/assets/img/officialHeader2.png"
              alt=""
            />
            <div
              class="reply_item_headbox_icon"
              :class="
                item.fromMemberAuthInfo && item.isOfficial == 0
                  ? 'memberAuthInfoFlag'
                  : ''
              "
              v-show="item.fromMemberAuthInfo"
            ></div>
            <div class="point" v-show="item.isread == 0"></div>
          </div>
          <div class="reply_item_con" @click="listClick(item)">
            <div class="reply_item_con_top">
              <div>{{ item.fromMemberNickName }} {{ item.description }}</div>
              <p class="reply_item_con_top_time" v-if="pageId != 3">
                {{ item.createTime ? item.createTime : '' }}
              </p>
              <p
                v-if="pageId == 3 && item.isFollow == 0"
                class="reply_item_con_top_btn"
                @click.stop="focusClick(item.relateKeyId)"
              >
                +关注
              </p>
              <P
                v-if="pageId == 3 && item.isFollow == 1"
                class="reply_item_con_top_alreadybtn"
                @click.stop="focusClick(item.relateKeyId)"
                >已关注</P
              >
            </div>
            <p
              class="reply_item_con_top_content"
              v-html="pageId != 3 ? item.content : item.createTime"
            ></p>
          </div>
        </div>
      </van-list>
      <div class="listPage_emptyicon" v-show="itemList.length == 0">
        <div class="listPage_emptyicon_icon"></div>
        <div
          class="msg_login_btn"
          @click="goLogin"
          v-if="$store.state.loginStatus === 0"
        >
          登录后查看
        </div>
        <div
          class="listPage_emptyicon_text"
          v-if="$store.state.loginStatus !== 0"
        >
          暂时还没有收到消息哦
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import get from '../../../api/get';
import qs from 'qs';
import { Toast } from 'vant';
import * as _code from '../../../utils/code';
export default {
  name: 'reply',
  components: {},
  props: {
    replyList: {
      type: Array,
      default: () => []
    },
    pageId: {
      type: Number,
      default: 1
    },
    nextFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultImg:
        this.$store.state.gameType != 1
          ? 'https://media.tentree-games.com/media/pictures/community/img/header.webp'
          : 'https://media.zlongame.com/media/pictures/cn/community/img/lzg_header.png',
      loading: false,
      finished: false,
      refreshing: false,
      itemList: [],
      nextPage: false
    };
  },
  watch: {
    replyList(ne, ol) {
      this.itemList = ne;
    },
    nextFlag(ne) {
      this.nextPage = ne;
      this.finished = !this.nextFlag;
      // if (!this.finished) {
      //   this.vueTouch()
      // }
    }
  },
  mounted() {
    // document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.itemList = this.replyList;
    this.nextPage = this.nextFlag;
    this.finished = false;
    this.loading = false;
    this.onLoad();
  },
  activated() {
    // this.onRefresh(true);
    // this.$emit('getUnread');
  },
  methods: {
    goLogin() {
      this.$store.commit('changeLoginShow', true);
    },
    changefinished(flag) {
      this.finished = flag;
    },
    defImg() {
      //图片错误展示默认图片
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    //下滑加载
    onLoad() {
      this.finished = false;
      // this.loading = true;
      setTimeout(() => {
        this.$emit('init', this.pageId, 'next', () => {
          this.loading = false;
        });
        // this.loading = true;
      }, 200);
    },
    vueTouch(text, e) {
      this.loading = true;
      this.finished = false;
      setTimeout(() => {
        this.$emit('init', this.pageId, 'next', () => {
          this.loading = false;
        });
      }, 1000);
    },
    //下拉刷新
    onRefresh(flag) {
      this.$emit('refresh', () => {
        this.refreshing = false;
        if (!flag) {
          // Toast('刷新完成');
        }
      });
    },
    //去用户主页
    goUserPage(item) {
      item.isread = 1;
      let objs = {
        type: this.pageId,
        messageId: item.id
      };
      get.messageRead(qs.stringify(objs)).then((res) => {});
      this.$router.push({
        name: 'otherHome',
        query: { id: item.fromMemberId }
      });
    },
    focusClick(id) {
      get.follow(id).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.itemList.forEach((item, index) => {
            if (item.relateKeyId == id) {
              item.isFollow = !item.isFollow;
              Toast(data.message);
            }
          });
        } else {
          this.errorMessage(data);
        }
      });
    },

    listClick(item) {
      switch (this.pageId) {
        case 1:
          item.isread = 1;
          if (item.groupTopicId) {
            let groupCommentId;
            item.type == 52001
              ? (groupCommentId = item.relateKeyId)
              : (groupCommentId = item.groupCommentId);
            this.$router.push({
              name: 'mesdetails',
              query: {
                relateKeyId: item.relateKeyId, //当前关联主键ID
                id: item.id,
                type: this.pageId,
                fromMemberId: item.fromMemberId,
                groupTopicId: item.groupTopicId, //当前所参与的帖子id
                topicContent: item.topicContent, //当前所参与的帖子缩略内容
                groupCommentId: groupCommentId //当前所参与内容所在一级评论的id
              }
            });
          } else {
            Toast('帖子已删除');
            let objs = {
              type: this.pageId,
              messageId: item.id
            };
            this.hasRead(objs);
            item.isread = 1;
          }
          // this.$emit("changetabList", 0, 1);
          break;
        case 2:
          item.isread = 1;
          if (
            item.type == 51001 ||
            item.type == 51003 ||
            item.type == 51004 ||
            item.type == 52001
          ) {
            this.$router.push({
              name: 'topicPage',
              query: { topicId: item.relateKeyId, isGame: true }
            });
            let objs = {
              type: this.pageId,
              messageId: item.id
            };
            this.hasRead(objs);
          } else if (
            item.type == 51005 ||
            item.type == 51006 ||
            item.type == 51002 ||
            item.type == 52002
          ) {
            if (item.groupTopicId) {
              let query = {
                relateKeyId: item.relateKeyId,
                id: item.id,
                type: this.pageId,
                fromMemberId: item.fromMemberId,
                groupTopicId: item.groupTopicId,
                topicContent: item.topicContent,
                groupCommentId: item.groupCommentId //当前所参与内容所在一级评论的id
              };
              if (item.type == 51005) {
                // query.groupCommentId = item.fromMemberId;
                this.$router.push({
                  name: 'mesdetails',
                  query: query
                });
              } else {
                this.$router.push({
                  name: 'mesdetails',
                  query: query
                });
              }
            } else {
              Toast('帖子已删除');
              let objs = {
                type: this.pageId,
                messageId: item.id
              };
              this.hasRead(objs);
              item.isread = 1;
            }
          }
          // this.$emit("changetabList", 1, 0);
          break;
        case 3:
          item.isread = 1;
          this.goUserPage(item);
          let objs = {
            type: this.pageId,
            messageId: item.id
          };
          this.hasRead(objs);
          break;
        case 4:
          item.isread = 1;
          this.$router.push({
            name: 'noticeShow',
            query: {
              content: item.content,
              type: this.pageId,
              id: item.id,
              title: item.description
            }
          });
          // this.$emit("changetabList", 3, 1);
          break;
        default:
          break;
      }
    },
    //上报已读
    hasRead(objs) {
      get.messageRead(qs.stringify(objs)).then((res) => {
        //上报已读
        let _data = res.data;
        this.$store.commit('changeMessageNum', [1, false]);
        if (_data.code == 0) {
          this.$emit('changetabList', objs.type - 1, _data.data.unReadNum);
        } else {
          this.errorMessage(_data.code);
        }
      });
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        // let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        // let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
        // Toast(msg);
      }
    }
  }
};
</script>
<style scoped>
.reply {
  height: 100vh;
}

.reply .van-pull-refresh {
  height: 100vh;
  /* overflow: auto; */
  background-color: #f5f5f5;
  /* margin-bottom: 0rem; */
}

.van-pull-refresh__track {
  height: 100vh;
}

.message_con .van-list {
  height: 100vh;
  overflow: auto;
}
</style>